module.exports = __webpack_public_path__ + "static/ORANA-c04626e2e7d7c6739b1cbf91b925606d.png";